<template>
  <div class="marketing-activity-create-or-edit">
    <el-form label-width="120px" ref="activityForm" :model="formData" :rules="formRules">
      <el-form-item label="活动标题：" prop="title">
        <el-input v-model.trim="formData.title" placeholder="10个字以内" :style="{width: formItemWidth}" clearable maxlength="10" />
      </el-form-item>

      <el-form-item label="活动副标题：" prop="subTitle">
        <el-input v-model="formData.subTitle" placeholder="20个字以内" :style="{width: formItemWidth}" clearable maxlength="20" />
      </el-form-item>

      <el-form-item label="活动时间：" prop="period">
        <el-date-picker
          v-model="formData.period"
          type="datetimerange"
          :style="{width: formItemWidth}"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleDateChange"
        />
      </el-form-item>

      <el-form-item label="活动任务：" prop="shareWx">
        <div class="flex flex-column">
          <el-checkbox :true-label="1" :false-label="0" v-model="formData.shareWx">将活动分享至微信好友</el-checkbox>
          <el-checkbox :true-label="1" :false-label="0" v-model="formData.commitNameTask">用户姓名提交</el-checkbox>
        </div>
      </el-form-item>

      <el-form-item label="奖品设置：" prop="prize">
        <el-button type="primary" block @click="handleAddPrize">＋ 添加奖品</el-button>
      </el-form-item>

      <el-form-item label="已选奖品：" v-if="formData.prize.length">
        <el-table border :data="formData.prize" size="small">
          <el-table-column align="center" label="奖品类型" prop="type">
            <template slot-scope="{row}">
              {{ prizeTypeMap[row.type] }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="奖品名称" prop="name" />
          <el-table-column align="center" label="总计数量" prop="num">
            <template slot-scope="{row}">
              {{ (row.numType === -1 || row.num === -1) ? '不限' : row.num }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="领取规则" prop="taskAuthPerson">
            <template slot-scope="{row}">
              <div v-html="getPickRules(row)"></div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="领取限制" prop="limitType">
            <template slot-scope="{row}">
              {{ getDisplayPickLimitText(row) }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="领取时间" prop="startTime">
            <template slot-scope="{row}">
              {{ formateDateTime(row.startTime, 'yyyy.MM.dd') }} ~ {{ formateDateTime(row.endTime, 'yyyy.MM.dd') }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" prop="action">
            <template slot-scope="{row, $index}">
              <el-popconfirm
                confirm-button-text='确认'
                cancel-button-text='取消'
                confirm-button-type="danger"
                icon="el-icon-info"
                icon-color="red"
                title="确认将奖品移除吗？"
                @confirm="()=>formData.prize = formData.prize.filter((_, idx) => idx !== $index)"
              >
                <el-link slot="reference" type="danger" size="small">移除</el-link>
              </el-popconfirm>
              <el-divider direction="vertical" />
              <el-link type="warning" size="small" @click="selectedPrize=row;selectedPrizeIndex=$index;showPrizeDialog=true">修改</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item label="活动规则：" prop="rule">
        <!-- <el-input v-model="formData.rule" type="textarea" placeholder="" :rows="4" :style="{width: formItemWidth}" clearable show-word-limit maxlength="9999" /> -->
        <Editor v-model="formData.rule" :toolbar="[]" plugins="image wordcount paste lists advlist" :limit-file-size="false" :default-value="formData.rule" :style="{width: formItemWidth}" />
      </el-form-item>

      <el-form-item label="分享页设置：" prop="shareTitle">
        <el-input v-model.trim="formData.shareTitle" placeholder="输入分享标题，30个字以内" :style="{width: formItemWidth}" clearable maxlength="30" />
      </el-form-item>

      <el-form-item label="" required prop="shareImgUrl">
        <div :style="{width: formItemWidth, height: formItemWidth, background: '#f8f8f8'}" class="rounded flex justify-center items-center">
          <div class="wechat-share-card flex items-start ml-2 w-full">
            <div style="background-color: #fff; width: 75%;" class="rounded-lg">
              <div class="p-4px">
                <div class="flex items-center text-xs">
                  <img src="@/assets/img/zxm-logo.png" class="rounded-full mr-4px" width="20px" height="20px">
                  智小美生活
                </div>

                <div class="text-sm my-4px">
                  {{ formData.shareTitle }}
                  <span v-if="!formData.shareTitle" class="text-gray">请在上方输入分享标题</span>
                </div>

                <div class="rounded-sm overflow-hidden share-image-uploader">
                  <Uploader v-model="formData.shareImgUrl" :multiple="false" width="260px" height="208px" :limit-file-size="false">
                    <div class="flex flex-column items-center justify-center share-image-uploader__placeholder">
                      <i class="el-icon-plus avatar-uploader-icon text-lg text-gray"></i>
                      <div class="text-gray text-sm">上传图片，建议长宽比：5:4</div>
                    </div>
                  </Uploader>
                </div>
              </div>
              <el-divider></el-divider>
              <div class="flex items-center text-xs p-4px">
                <img src="@/assets/img/wechat-miniprogram.png" class="mr-2px" width="12px" height="12px">
                小程序
              </div>
            </div>
            <div class="ml-4px no-shrink">
              <el-avatar shape="square" size="medium" src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"></el-avatar>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="联系电话：" prop="phone">
        <el-input v-model="formData.phone" placeholder="输入联系电话" maxlength="20" :style="{width: formItemWidth}" />
      </el-form-item>

      <div class="flex justify-center">
        <el-button :loading="loading" @click="handleSave" type="primary">{{ activityId ? '确认修改' : '确认创建' }}</el-button>
      </div>
    </el-form>

    <PrizeDialog :activityPeriod="formData.period" :itemData="selectedPrize" :show.sync="showPrizeDialog" @close="selectedPrize = null;selectedPrizeIndex=-1;" @confirm="handlePrizeSave" />
  </div>
</template>

<script>
import { postSaveActivityApi, getActivityDetailApi } from '@/api'
import { isTele } from '@/utils/is'
import { formateDateTime } from '@/utils/datetime'
import Editor from '@/components/Editor/index.vue'
import Uploader from '@/components/Uploader/index.vue'
import PrizeDialog from './components/PrizeDialog/index.vue';
export default {
  name: "MarketingActivityCreateOrEdit",
  components: { Uploader, PrizeDialog, Editor },
  data() {
    return {
      showPrizeDialog: false,
      formItemWidth: '400px',
      formateDateTime,

      // 编辑时活动id
      activityId: null,
      itemData: null,

      loading: false,

      // 选中编辑的奖品
      selectedPrize: null,
      selectedPrizeIndex: -1,

      prizeTypeMap: {
        10: '智小美生活卡',
        20: '实物',
        30: '优惠券',
        40: '红包',
      },

      formData: {
        title: '',
        subTitle: '',
        period: null,
        prize: [],
        rule: '',
        shareTitle: '',
        shareImgUrl: '',
        shareWx: 0,
        phone: '',
        commitNameTask: '',
      },

      formRules: {
        title: [
          {required: true, message: '请输入活动标题', trigger: 'change'},
          {validator: (rule, value, callback) => {
            if (value.includes('%')) {
              callback('不能包含符号：% ')
            } else {
              callback()
            }
          }}
        ],
        period: [
          {required: true, message: '请选择活动时间', trigger: 'change'},
          {
            validator: (rule, value, callback) => {
              if (!value || value.length < 2) {
                callback('请选择活动时间')
              } else {
                if (this.activityId) {
                  return callback()
                }
                let [start, end] = value
                let now = new Date()
                start = new Date(start)
                end = new Date(end)
                if (start < now) {
                  callback('开始时间需大于当前时间')
                } else if (end < start) {
                  callback('结束时间需大于开始时间')
                } else {
                  callback()
                }
              }
            },
            trigger: 'blur'
          }
        ],
        phone: [
          {
            validator: (rule, value, callback) => {
              if (value && !isTele(value)) {
                callback('请输入正确的手机号')
              } else {
                callback()
              }
            }
          }
        ],
        prize: [
          {required: true, message: '请设置奖品', trigger: 'change'},
          {
            validator: (rule, value, callback) => {
              if (value.length < 1) {
                callback('请设置奖品')
              } else if (!this.isValidPrizePickTime()) {
                callback('奖品领取时间不在活动时间内！')
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        rule: [{required: true, message: '请输入活动规则', trigger: 'change'}, {max: 9999, min: 1, message: '请输入1-9999位字符', trigger: 'blur'}],
        shareTitle: [
          {required: true, message: '请输入分享标题', trigger: 'change'},
        ],
        shareImgUrl: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback('请上传分享图片')
              } else {
                callback()
              }
            },
            trigger: 'blur',
          }
        ],
      },
    }
  },
  beforeRouteEnter(to, from, next) {
    // 动态修改面包屑中的活动名称
    to.meta.title = to.query.title ? '活动编辑页' : '创建活动'
    next()
  },
  async beforeMount() {
    if (this.$route.query.id) {
      this.activityId = this.$route.query.id
      await this.loadData()
    }
  },
  methods: {
    /** 奖品表格中的“领取限制”文字显示 */
    getDisplayPickLimitText(row) {
      let {limitType, limitNum, type} = row
      let unit = (type === 10 || type === 30) ? '张' : '份'
      return limitType === 10 ? '不限数量' : limitType === 20 ? `每个用户仅限 ${limitNum} ${unit}` : limitType === 30 ? `每户仅限 ${limitNum} ${unit}` : ''
    },

    getPickRules(row) {
      let list = []
      if (row.taskAuthPerson === 1) {
        list.push('农户身份认证')
      }
      if (this.formData.shareWx === 1) {
        list.push('分享好友')
      }
      if (this.formData.commitNameTask === 1) {
        list.push('用户姓名提交')
      }

      return list.map((item, index) => `<div>${list.length>1 ? index+1+'、' : ''}${item}</div>`).join('')
    },

    /** 活动时间精确到"时" */
    handleDateChange(data) {
      this.formData.period = [data[0].split(':')[0] + ':00:00', data[1].split(':')[0] + ':00:00']
    },

    /** 编辑时检查奖品领取时间是否在活动时间内 */
    isValidPrizePickTime() {
      let {period, prize} = this.formData
      if (!period || !period.length) {
        return false
      }

      let [start, end] = period
      start = new Date(start)
      end = new Date(end)

      for(let i = 0; i < prize.length; i++) {
        let {startTime, endTime} = prize[i]
        startTime = new Date(startTime)
        endTime = new Date(endTime)
        if (startTime < start || endTime > end) {
          return false
        }
      }
      return true
    },

    /** “添加奖品”按钮，未设置活动时间时，弹框提示 */
    handleAddPrize() {
      if (!this.formData.period || !this.formData.period.length) {
        return this.$message.warning('请先设置活动时间！')
      }
      this.showPrizeDialog=true
    },

    /** 新增/编辑奖品的确认按钮 */
    handlePrizeSave(prizeObj) {
      try {
        if (this.selectedPrize) { // 编辑
          let newPrizes = JSON.parse(JSON.stringify(this.formData.prize))
          newPrizes.forEach((item, index) => {
            if (index === this.selectedPrizeIndex) {
              Object.assign(item, prizeObj)
            }
          })
          this.formData.prize = [...newPrizes]
        } else { // 新增
          this.formData.prize.push(prizeObj)
        }
      } catch(err) {
        console.log(err)
      }
    },
    
    /** 创建/编辑活动 */
    async handleSave() {
      try {
        this.loading = true
        await this.$refs.activityForm.validate()
        let data = {...this.formData}
        data.endTime = data.period[1]
        data.startTime = data.period[0]
        // 商家名称
        data.businessName = ''
        let res = await postSaveActivityApi(data)
        this.loading = false
        if (res.code === 0) {
          this.$message.success(`${this.activityId ? '修改' : '创建'}成功！`)
          this.$router.back()
        }
      } catch(err) {
        console.log(err)
        this.loading = false
      }
    },

    /** 获取活动详情 */
    async loadData() {
      try {
        let res = await getActivityDetailApi(this.activityId)
        if (res.code === 0) {
          this.itemData = res.data
          this.formData = {...this.formData, ...res.data, period: [res.data.startTime, res.data.endTime]}
        }
      } catch(err) {
        console.log(err)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.wechat-share-card {
  /deep/ .el-divider--horizontal {
    margin: 4px 0;
  }
}

.share-image-uploader {
  overflow: hidden;
  width: 260px;
  height: 208px;
  border: 1px solid #d7dae2;

  &__placeholder {
    width: 260px;
    height: 208px;
    background-color: #f8f8f8;
  }

  /deep/ .el-upload-list {
    width: 100%;
    height: 100%;
    .el-upload-list__item {
      width: 100%;
      height: 100%;
      margin: 0;
      border-radius: 0;
    }
  }

  /deep/ .el-upload--picture-card {
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 0;
  }
}
</style>